import { studentsUnpinTag } from '@/store/apply/actions';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { TableCellProps } from '../types';

export function useTagDeletion() {
  const dispatch = useDispatch();

  const [isTagDeleteConfirmationModal, setTagDeleteConfirmationModal] = useState(false);

  const unpinTagFromStudent = useCallback(
    ({ offerId, applicantId, tag }) => {
      dispatch(studentsUnpinTag(offerId, applicantId, tag));
    },
    [dispatch],
  );

  const onTagDelete = useCallback((tagId: string, _, row: TableCellProps['row']) => {
    setTagDeleteModalData({
      title: 'Remove Tag From Student?',
      buttonName: 'Confirm',
      clickAction: () => {
        const tag = { id: tagId };
        unpinTagFromStudent({ offerId: row.offerId, applicantId: row.userId, tag });
        setTagDeleteConfirmationModal(false);
      },
    });
    setTagDeleteConfirmationModal(true);
  }, []);

  const [tagDeleteModalData, setTagDeleteModalData] = useState({
    clickAction: () => {},
    title: '',
    buttonName: '',
  });

  return {
    isTagDeleteConfirmationModal,
    setTagDeleteConfirmationModal,
    tagDeleteModalData,
    onTagDelete,
  };
}
